import { computed } from 'vue'
import { useServicesStore } from '@/stores/services'
import { storeToRefs } from 'pinia'

export function useBottomBarUnits() {
    const serv = useServicesStore()
    const { unitsOnline } = storeToRefs(serv)

    const parseUtcString = (utcStr: string) => {
        // Convierte "2025-06-13 16:57:50.009" a "2025-06-13T16:57:50.009Z"
        return new Date(utcStr.replace(' ', 'T') + 'Z')
    }

    const filteredUnitsOnline = computed(() => {
        const now = Date.now()
        return Array.isArray(unitsOnline.value)
            ? unitsOnline.value
                .filter(
                    (unit) =>
                        (unit.rol === 1) &&
                        unit.location &&
                        Array.isArray(unit.location.coordinates) &&
                        unit.location.coordinates.length === 2 &&
                        typeof unit.location.coordinates[0] === 'number' &&
                        typeof unit.location.coordinates[1] === 'number'
                )
                .map(unit => {
                    let estado = 0
                    if (unit.utc) {
                        const unitTime = parseUtcString(unit.utc).getTime()
                        if (!isNaN(unitTime) && Math.abs(now - unitTime) < 60000) {
                            estado = 1
                        }
                    }
                    return { ...unit, estado }
                })
            : []
    })
    const filteredPatrullasOnline = computed(() => {
        const now = Date.now()
        return Array.isArray(unitsOnline.value)
            ? unitsOnline.value
                .filter(
                    (unit) =>
                        (unit.rol === 15) &&
                        unit.location &&
                        Array.isArray(unit.location.coordinates) &&
                        unit.location.coordinates.length === 2 &&
                        typeof unit.location.coordinates[0] === 'number' &&
                        typeof unit.location.coordinates[1] === 'number'
                )
                .map(unit => {
                    let estado = 0
                    if (unit.utc) {
                        const unitTime = parseUtcString(unit.utc).getTime()
                        if (!isNaN(unitTime) && Math.abs(now - unitTime) < 60000) {
                            estado = 1
                        }
                    }
                    return { ...unit, estado }
                })
            : []
    })
    const basesOnline = computed(() => {
        return Array.isArray(unitsOnline.value)
            ? unitsOnline.value
                .filter(
                    (unit) =>
                        (unit.rol === 3) &&
                        unit.location &&
                        Array.isArray(unit.location.coordinates) &&
                        unit.location.coordinates.length === 2 &&
                        typeof unit.location.coordinates[0] === 'number' &&
                        typeof unit.location.coordinates[1] === 'number'
                )
                .map(unit => {
                    const estado = 1
                    return { ...unit, estado }
                })
            : []
    })

    // Función genérica para obtener el mission de una unidad específica
    const getMissionByUnitId = (unitId: string): string | null => {
        if (!unitId) return null

        const unit = unitsOnline.value.find(unit => unit.unit_id === unitId)

        if (unit && unit.mission) {
            console.log(`📋 Mission encontrado para unidad ${unitId}:`, unit.mission)
            return unit.mission.toString()
        } else {
            console.warn(`⚠️ No se encontró mission para la unidad ${unitId}`)
            return null
        }
    }

    return {
        filteredUnitsOnline,
        filteredPatrullasOnline,
        basesOnline,
        getMissionByUnitId,
        unitsOnline
    }
}
